import { AdminApi } from './data/api/admin/adminApi';
import { inject, injectable } from './modules/common/di';
import { AdminApiDal } from "./data/api/admin/adminApiDal";
import { ReportApiDal } from "./data/api/admin/reports/reportApiDal";
import { OrganizationService } from './data/services/organizationService';
import { TagsService } from './data/services/tagsService';
import { ChallengeService } from './data/services/challengeService';
import { ReportsService } from './data/services/reportsService';
import { LocationAdminService } from './data/services/locationService';
import { DeviceAdminService } from './data/services/deviceService';
import { UserAdminService } from './data/services/userService';
import { FirmwareService } from './data/services/firmwareService';
import { BillingService } from './data/services/billingService';
import { NotificationService } from './data/services/notificationService';

// NOTE: Do not ever refer to '@peoplepower/webcore' instead of '@peoplepower/webcore/dist/types/webcore' in this package,
// because it will use separate build of WebCore, which will lead to instance doubling problem.
import { WebCore, WebCoreApis, WebCoreDals, WebCoreServices } from '@peoplepower/webcore/dist/types/webcore';

@injectable('AdminWebCoreApis')
export class AdminWebCoreApis extends WebCoreApis {
  @inject('AdminApi') admin!: AdminApi;
}

@injectable('AdminWebCoreServices')
export class AdminWebCoreServices extends WebCoreServices {
  @inject('OrganizationService') organization!: OrganizationService;
  @inject('TagsService') tags!: TagsService;
  @inject('ChallengeService') challenge!: ChallengeService;
  @inject('ReportsService') reports!: ReportsService;
  @inject('LocationAdminService') override location!: LocationAdminService;
  @inject('DeviceAdminService') override device!: DeviceAdminService;
  @inject('UserAdminService') override user!: UserAdminService;
  @inject('FirmwareService') firmware!: FirmwareService;
  @inject('BillingService') billing!: BillingService;
  @inject('NotificationService') notification!: NotificationService;
}

@injectable('AdminWebCoreDals')
export class AdminWebCoreDals extends WebCoreDals {
  @inject('AdminApiDal') public readonly AdminApiDal!: AdminApiDal;
  @inject('ReportApiDal') public readonly ReportApiDal!: ReportApiDal;
}

@injectable('AdminWebCore')
export class AdminWebCore extends WebCore {
  @inject('AdminWebCoreApis') public override api!: AdminWebCoreApis;
  @inject('AdminWebCoreServices') public override services!: AdminWebCoreServices;
  @inject('AdminWebCoreDals') public override dals!: AdminWebCoreDals;
}
